<template>
    <div class="mt-6 flex justify-center bg-gray-400/20">
        <div class="grid grid-cols-1 lg:grid-cols-2">
            <img class="object-cover" src="/images/detail_foot.jpg">
            <p class="flex justify-center items-center m-5 lg:mx-20 text-justify leading-8">200 多年来，SAUTER 钢琴只在德国南部巴登符腾堡州的Spaichingen (施派欣根) 生产与组装、只使用德国生产的零部件、每一个重要步骤皆由德国制琴大师手工精心打造，确保了SAUTER 钢琴的杰出工艺品质和诚实的德国血统。  </p>
        </div>
    </div>
</template>